/**
 * Vineyard Management Solution API
 * Client-Server間のwebAPI仕様書です。
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { Contract } from '../model/contract';
import { ContractCustomer } from '../model/contractCustomer';
import { ContractFieldMeasurement } from '../model/contractFieldMeasurement';
import { ContractFieldPathTestRunSet } from '../model/contractFieldPathTestRunSet';
import { ContractFieldTestRunSet } from '../model/contractFieldTestRunSet';
import { ContractMachine } from '../model/contractMachine';
import { ContractUser } from '../model/contractUser';
import { CoordinateData } from '../model/coordinateData';
import { Field } from '../model/field';
import { FieldMeasurementCoordinateInfo } from '../model/fieldMeasurementCoordinateInfo';
import { FieldMeasurementData } from '../model/fieldMeasurementData';
import { FieldPathData } from '../model/fieldPathData';
import { Implement } from '../model/implement';
import { Machine } from '../model/machine';
import { MachineOperationInfo } from '../model/machineOperationInfo';
import { Recipe } from '../model/recipe';
import { VineyardUser } from '../model/vineyardUser';
import { WorkFieldRunPathInfo } from '../model/workFieldRunPathInfo';
import { WorkHistory } from '../model/workHistory';
import { WorkPath } from '../model/workPath';
import { WorkPlan } from '../model/workPlan';

import { environment } from '@Environment/environment';
import { Configuration } from '../configuration';
import { BASE_PATH } from '../variables';

@Injectable()
export class VineyardWebApi {
  protected basePath = `${environment.vsolServerUrl}/api/v1`;
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * [契約顧客]を1件取得する
   * * [契約顧客]を1件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param contractcustomerid 契約顧客ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractCustomersContractCustomerIdGet(
    contractcustomerid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractCustomer>;
  public contractCustomersContractCustomerIdGet(
    contractcustomerid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractCustomer>>;
  public contractCustomersContractCustomerIdGet(
    contractcustomerid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractCustomer>>;
  public contractCustomersContractCustomerIdGet(
    contractcustomerid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractcustomerid === null || contractcustomerid === undefined) {
      throw new Error(
        'Required parameter contractcustomerid was null or undefined when calling contractCustomersContractCustomerIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ContractCustomer>(
      'get',
      `${this.basePath}/contractcustomers/${encodeURIComponent(String(contractcustomerid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約顧客]を更新する
   * 契約顧客を更新する
   * @param body
   * @param contractcustomerid 契約顧客ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractCustomersContractCustomerIdPut(
    body: ContractCustomer,
    contractcustomerid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractCustomer>;
  public contractCustomersContractCustomerIdPut(
    body: ContractCustomer,
    contractcustomerid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractCustomer>>;
  public contractCustomersContractCustomerIdPut(
    body: ContractCustomer,
    contractcustomerid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractCustomer>>;
  public contractCustomersContractCustomerIdPut(
    body: ContractCustomer,
    contractcustomerid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractCustomersContractCustomerIdPut.'
      );
    }

    if (contractcustomerid === null || contractcustomerid === undefined) {
      throw new Error(
        'Required parameter contractcustomerid was null or undefined when calling contractCustomersContractCustomerIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractCustomer>(
      'put',
      `${this.basePath}/contractcustomers/${encodeURIComponent(String(contractcustomerid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * 契約顧客の作業予定を1件取得する
   * 契約顧客の作業予定を1件取得する
   * @param contractcustomerid 契約顧客ID
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdGet(
    contractcustomerid: number,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdGet(
    contractcustomerid: number,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdGet(
    contractcustomerid: number,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdGet(
    contractcustomerid: number,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractcustomerid === null || contractcustomerid === undefined) {
      throw new Error(
        'Required parameter contractcustomerid was null or undefined when calling contractCustomersContractCustomerIdWorkPlansWorkPlanIdGet.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling contractCustomersContractCustomerIdWorkPlansWorkPlanIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<WorkPlan>(
      'get',
      `${this.basePath}/contractcustomer/${encodeURIComponent(String(contractcustomerid))}/workplans/${encodeURIComponent(String(workplanid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * 契約顧客の作業の作業圃場走行経路情報を取得する
   * 契約顧客の作業の作業圃場走行経路情報を取得する
   * @param contractcustomerid 契約顧客ID
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkFieldRunPathInfosGet(
    contractcustomerid: number,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<WorkFieldRunPathInfo>>;
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkFieldRunPathInfosGet(
    contractcustomerid: number,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<WorkFieldRunPathInfo>>>;
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkFieldRunPathInfosGet(
    contractcustomerid: number,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<WorkFieldRunPathInfo>>>;
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkFieldRunPathInfosGet(
    contractcustomerid: number,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractcustomerid === null || contractcustomerid === undefined) {
      throw new Error(
        'Required parameter contractcustomerid was null or undefined when calling contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkFieldRunPathInfosGet.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkFieldRunPathInfosGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<WorkFieldRunPathInfo>>(
      'get',
      `${this.basePath}/contractcustomer/${encodeURIComponent(String(contractcustomerid))}/workplans/${encodeURIComponent(String(workplanid))}/workfieldrunpathinfos`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * 契約顧客の作業の作業履歴を取得する
   * 契約顧客の作業の作業履歴を取得する
   * @param contractcustomerid 契約顧客ID
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkHistoriesGet(
    contractcustomerid: number,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<WorkHistory>>;
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkHistoriesGet(
    contractcustomerid: number,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<WorkHistory>>>;
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkHistoriesGet(
    contractcustomerid: number,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<WorkHistory>>>;
  public contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkHistoriesGet(
    contractcustomerid: number,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractcustomerid === null || contractcustomerid === undefined) {
      throw new Error(
        'Required parameter contractcustomerid was null or undefined when calling contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkHistoriesGet.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling contractCustomersContractCustomerIdWorkPlansWorkPlanIdWorkHistoriesGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<WorkHistory>>(
      'get',
      `${this.basePath}/contractcustomer/${encodeURIComponent(String(contractcustomerid))}/workplans/${encodeURIComponent(String(workplanid))}/workhistories`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * 契約顧客の作業予定を取得する
   * 契約顧客の作業予定を取得する
   * @param contractcustomerid 契約顧客ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractCustomersContractCustomerIdWorkplansGet(
    contractcustomerid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<WorkPlan>>;
  public contractCustomersContractCustomerIdWorkplansGet(
    contractcustomerid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<WorkPlan>>>;
  public contractCustomersContractCustomerIdWorkplansGet(
    contractcustomerid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<WorkPlan>>>;
  public contractCustomersContractCustomerIdWorkplansGet(
    contractcustomerid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractcustomerid === null || contractcustomerid === undefined) {
      throw new Error(
        'Required parameter contractcustomerid was null or undefined when calling contractCustomersContractCustomerIdWorkplansGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<WorkPlan>>(
      'get',
      `${this.basePath}/contractcustomer/${encodeURIComponent(String(contractcustomerid))}/workplans`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約顧客]を複数件取得する
   * * [契約顧客]を複数件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractCustomersGet(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContractCustomer>>;
  public contractCustomersGet(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContractCustomer>>>;
  public contractCustomersGet(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContractCustomer>>>;
  public contractCustomersGet(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<ContractCustomer>>(
      'get',
      `${this.basePath}/contractcustomers`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約顧客]を登録する
   * 契約顧客を登録する
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractCustomersPost(
    body: ContractCustomer,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractCustomer>;
  public contractCustomersPost(
    body: ContractCustomer,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractCustomer>>;
  public contractCustomersPost(
    body: ContractCustomer,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractCustomer>>;
  public contractCustomersPost(
    body: ContractCustomer,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractCustomersPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractCustomer>(
      'post',
      `${this.basePath}/contractcustomers`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * 圃場測量座標情報を取得する
   * 圃場測量座標情報を取得する
   * @param contractfieldid 契約圃場ID
   * @param contractfieldmeasurementid 契約圃場測量ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<FieldMeasurementCoordinateInfo>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<FieldMeasurementCoordinateInfo>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<FieldMeasurementCoordinateInfo>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet.'
      );
    }

    if (
      contractfieldmeasurementid === null ||
      contractfieldmeasurementid === undefined
    ) {
      throw new Error(
        'Required parameter contractfieldmeasurementid was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<FieldMeasurementCoordinateInfo>(
      'get',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldmeasurements/${encodeURIComponent(String(contractfieldmeasurementid))}/fieldmeasurementcoordinateinfo`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [圃場測量ファイル]を1件取得する
   * * [圃場測量ファイル]を1件取得する。
   * @param contractfieldid 契約圃場ID
   * @param contractfieldmeasurementid 契約圃場測量ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementDataGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<FieldMeasurementData>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementDataGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<FieldMeasurementData>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementDataGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<FieldMeasurementData>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementDataGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementDataGet.'
      );
    }

    if (
      contractfieldmeasurementid === null ||
      contractfieldmeasurementid === undefined
    ) {
      throw new Error(
        'Required parameter contractfieldmeasurementid was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementDataGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<FieldMeasurementData>(
      'get',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldmeasurements/${encodeURIComponent(String(contractfieldmeasurementid))}/fieldmeasurementdata`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場測量]を1件取得する
   * * [契約圃場測量]を1件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param contractfieldid 契約圃場ID
   * @param contractfieldmeasurementid 契約圃場測量ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldMeasurement>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldMeasurement>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldMeasurement>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdGet(
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdGet.'
      );
    }

    if (
      contractfieldmeasurementid === null ||
      contractfieldmeasurementid === undefined
    ) {
      throw new Error(
        'Required parameter contractfieldmeasurementid was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ContractFieldMeasurement>(
      'get',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldmeasurements/${encodeURIComponent(String(contractfieldmeasurementid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場測量]を更新する
   * 契約圃場測量を更新する
   * @param body
   * @param contractfieldid 契約圃場ID
   * @param contractfieldmeasurementid 契約圃場測量ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdPut(
    body: ContractFieldMeasurement,
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldMeasurement>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdPut(
    body: ContractFieldMeasurement,
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldMeasurement>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdPut(
    body: ContractFieldMeasurement,
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldMeasurement>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdPut(
    body: ContractFieldMeasurement,
    contractfieldid: number,
    contractfieldmeasurementid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdPut.'
      );
    }

    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdPut.'
      );
    }

    if (
      contractfieldmeasurementid === null ||
      contractfieldmeasurementid === undefined
    ) {
      throw new Error(
        'Required parameter contractfieldmeasurementid was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsContractFieldMeasurementIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldMeasurement>(
      'put',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldmeasurements/${encodeURIComponent(String(contractfieldmeasurementid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場測量]を複数件取得する
   * * [契約圃場測量]を複数件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param contractfieldid 契約圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldMeasurementsGet(
    contractfieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContractFieldMeasurement>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsGet(
    contractfieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContractFieldMeasurement>>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsGet(
    contractfieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContractFieldMeasurement>>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsGet(
    contractfieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<ContractFieldMeasurement>>(
      'get',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldmeasurements`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場測量]を登録する
   * 契約圃場測量を登録する
   * @param body
   * @param contractfieldid 契約圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldMeasurementsPost(
    body: ContractFieldMeasurement,
    contractfieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldMeasurement>;
  public contractFieldsContractFieldIdContractFieldMeasurementsPost(
    body: ContractFieldMeasurement,
    contractfieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldMeasurement>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsPost(
    body: ContractFieldMeasurement,
    contractfieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldMeasurement>>;
  public contractFieldsContractFieldIdContractFieldMeasurementsPost(
    body: ContractFieldMeasurement,
    contractfieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsPost.'
      );
    }

    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldMeasurementsPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldMeasurement>(
      'post',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldmeasurements`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場経路]と[試走用契約圃場経路]を削除する
   * [契約圃場経路]を削除する
   * @param body
   * @param contractfieldid 契約圃場ID
   * @param contractfieldpathid 契約圃場経路ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdDeletePut(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldPathTestRunSet>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdDeletePut(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldPathTestRunSet>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdDeletePut(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldPathTestRunSet>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdDeletePut(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    contractfieldpathid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdDeletePut.'
      );
    }

    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdDeletePut.'
      );
    }

    if (contractfieldpathid === null || contractfieldpathid === undefined) {
      throw new Error(
        'Required parameter contractfieldpathid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdDeletePut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldPathTestRunSet>(
      'put',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldpaths/${encodeURIComponent(String(contractfieldpathid))}/delete`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [圃場経路ファイル]を1件取得する
   * * [圃場経路ファイル]を1件取得する。
   * @param contractfieldid 契約圃場ID
   * @param contractfieldpathid 契約圃場経路ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdFieldPathDataGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<FieldPathData>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdFieldPathDataGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<FieldPathData>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdFieldPathDataGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<FieldPathData>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdFieldPathDataGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdFieldPathDataGet.'
      );
    }

    if (contractfieldpathid === null || contractfieldpathid === undefined) {
      throw new Error(
        'Required parameter contractfieldpathid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdFieldPathDataGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<FieldPathData>(
      'get',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldpaths/${encodeURIComponent(String(contractfieldpathid))}/fieldpathdata`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場経路]と[試走用契約圃場経路]を1件取得する
   * * [契約圃場経路]を1件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param contractfieldid 契約圃場ID
   * @param contractfieldpathid 契約圃場経路ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldPathTestRunSet>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldPathTestRunSet>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldPathTestRunSet>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdGet.'
      );
    }

    if (contractfieldpathid === null || contractfieldpathid === undefined) {
      throw new Error(
        'Required parameter contractfieldpathid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ContractFieldPathTestRunSet>(
      'get',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldpaths/${encodeURIComponent(String(contractfieldpathid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場経路]と[試走用契約圃場経路]を更新する
   * 契約圃場経路を更新する
   * @param body
   * @param contractfieldid 契約圃場ID
   * @param contractfieldpathid 契約圃場経路ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdPut(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldPathTestRunSet>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdPut(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldPathTestRunSet>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdPut(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldPathTestRunSet>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdPut(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    contractfieldpathid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdPut.'
      );
    }

    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdPut.'
      );
    }

    if (contractfieldpathid === null || contractfieldpathid === undefined) {
      throw new Error(
        'Required parameter contractfieldpathid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldPathTestRunSet>(
      'put',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldpaths/${encodeURIComponent(String(contractfieldpathid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * 作業圃場走行経路情報を取得する
   * 作業圃場走行経路情報を取得する
   * @param contractfieldid 契約圃場ID
   * @param contractfieldpathid 契約圃場経路ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdWorkRunPathInfoGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<WorkFieldRunPathInfo>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdWorkRunPathInfoGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<WorkFieldRunPathInfo>>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdWorkRunPathInfoGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<WorkFieldRunPathInfo>>>;
  public contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdWorkRunPathInfoGet(
    contractfieldid: number,
    contractfieldpathid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdWorkRunPathInfoGet.'
      );
    }

    if (contractfieldpathid === null || contractfieldpathid === undefined) {
      throw new Error(
        'Required parameter contractfieldpathid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsContractFieldPathIdWorkRunPathInfoGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<WorkFieldRunPathInfo>>(
      'get',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldpaths/${encodeURIComponent(String(contractfieldpathid))}/workrunpathinfo`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場経路]と[試走用契約圃場経路]を複数件取得する
   * * [契約圃場経路]を複数件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param contractfieldid 契約圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldPathsGet(
    contractfieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContractFieldPathTestRunSet>>;
  public contractFieldsContractFieldIdContractFieldPathsGet(
    contractfieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContractFieldPathTestRunSet>>>;
  public contractFieldsContractFieldIdContractFieldPathsGet(
    contractfieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContractFieldPathTestRunSet>>>;
  public contractFieldsContractFieldIdContractFieldPathsGet(
    contractfieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<ContractFieldPathTestRunSet>>(
      'get',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldpaths`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場経路]と[試走用契約圃場経路]を登録する
   * 契約圃場経路を登録する
   * @param body
   * @param contractfieldid 契約圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdContractFieldPathsPost(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldPathTestRunSet>;
  public contractFieldsContractFieldIdContractFieldPathsPost(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldPathTestRunSet>>;
  public contractFieldsContractFieldIdContractFieldPathsPost(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldPathTestRunSet>>;
  public contractFieldsContractFieldIdContractFieldPathsPost(
    body: ContractFieldPathTestRunSet,
    contractfieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsPost.'
      );
    }

    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdContractFieldPathsPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldPathTestRunSet>(
      'post',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/contractfieldpaths`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [coordinateファイル]を1件取得する
   * * [coordinateファイル]を1件取得する。
   * @param contractFieidMeasurementIdList
   * @param contractfieldid 契約圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdCoordinateDataGet(
    contractFieidMeasurementIdList: Array<number>,
    contractfieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CoordinateData>;
  public contractFieldsContractFieldIdCoordinateDataGet(
    contractFieidMeasurementIdList: Array<number>,
    contractfieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<CoordinateData>>;
  public contractFieldsContractFieldIdCoordinateDataGet(
    contractFieidMeasurementIdList: Array<number>,
    contractfieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CoordinateData>>;
  public contractFieldsContractFieldIdCoordinateDataGet(
    contractFieidMeasurementIdList: Array<number>,
    contractfieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (
      contractFieidMeasurementIdList === null ||
      contractFieidMeasurementIdList === undefined
    ) {
      throw new Error(
        'Required parameter contractFieidMeasurementIdList was null or undefined when calling contractFieldsContractFieldIdCoordinateDataGet.'
      );
    }

    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdCoordinateDataGet.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (contractFieidMeasurementIdList) {
      contractFieidMeasurementIdList.forEach((element) => {
        queryParameters = queryParameters.append(
          'contractFieidMeasurementIdList',
          <any>element
        );
      });
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<CoordinateData>(
      'get',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/coordinatedata`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場]と[試走用契約圃場]をコピーする
   * 圃場をコピーする
   * @param body
   * @param contractfieldid 契約圃場ID
   * @param dealerid ディーラーID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdCopyDealerIdPost(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    dealerid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldTestRunSet>;
  public contractFieldsContractFieldIdCopyDealerIdPost(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    dealerid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldTestRunSet>>;
  public contractFieldsContractFieldIdCopyDealerIdPost(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    dealerid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldTestRunSet>>;
  public contractFieldsContractFieldIdCopyDealerIdPost(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    dealerid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractFieldsContractFieldIdCopyDealerIdPost.'
      );
    }

    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdCopyDealerIdPost.'
      );
    }

    if (dealerid === null || dealerid === undefined) {
      throw new Error(
        'Required parameter dealerid was null or undefined when calling contractFieldsContractFieldIdCopyDealerIdPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldTestRunSet>(
      'post',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/copy/${encodeURIComponent(String(dealerid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場]と[試走用契約圃場]を削除する
   * [契約圃場]を削除する
   * @param body
   * @param contractfieldid 契約圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdDeletePut(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldTestRunSet>;
  public contractFieldsContractFieldIdDeletePut(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldTestRunSet>>;
  public contractFieldsContractFieldIdDeletePut(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldTestRunSet>>;
  public contractFieldsContractFieldIdDeletePut(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractFieldsContractFieldIdDeletePut.'
      );
    }

    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdDeletePut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldTestRunSet>(
      'put',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}/delete`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場]と[試走用契約圃場]を1件取得する
   * * [契約圃場]と[試走用契約圃場]を1件取得する
   * @param contractfieldid 契約圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdGet(
    contractfieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldTestRunSet>;
  public contractFieldsContractFieldIdGet(
    contractfieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldTestRunSet>>;
  public contractFieldsContractFieldIdGet(
    contractfieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldTestRunSet>>;
  public contractFieldsContractFieldIdGet(
    contractfieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ContractFieldTestRunSet>(
      'get',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場]と[試走用契約圃場]を更新する
   * 契約圃場を更新する
   * @param body
   * @param contractfieldid 契約圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsContractFieldIdPut(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldTestRunSet>;
  public contractFieldsContractFieldIdPut(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldTestRunSet>>;
  public contractFieldsContractFieldIdPut(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldTestRunSet>>;
  public contractFieldsContractFieldIdPut(
    body: ContractFieldTestRunSet,
    contractfieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractFieldsContractFieldIdPut.'
      );
    }

    if (contractfieldid === null || contractfieldid === undefined) {
      throw new Error(
        'Required parameter contractfieldid was null or undefined when calling contractFieldsContractFieldIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldTestRunSet>(
      'put',
      `${this.basePath}/contractfields/${encodeURIComponent(String(contractfieldid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場]と[試走用契約圃場]を複数件取得する
   * * [契約圃場]を複数件取得する。
   * @param contractCustomerId 契約顧客ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsGet(
    contractCustomerId?: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContractFieldTestRunSet>>;
  public contractFieldsGet(
    contractCustomerId?: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContractFieldTestRunSet>>>;
  public contractFieldsGet(
    contractCustomerId?: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContractFieldTestRunSet>>>;
  public contractFieldsGet(
    contractCustomerId?: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (contractCustomerId !== undefined && contractCustomerId !== null) {
      queryParameters = queryParameters.set(
        'contractCustomerId',
        <any>contractCustomerId
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<ContractFieldTestRunSet>>(
      'get',
      `${this.basePath}/contractfields`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場]と[試走用契約圃場]を登録する
   * 契約圃場を登録する
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractFieldsPost(
    body: ContractFieldTestRunSet,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldTestRunSet>;
  public contractFieldsPost(
    body: ContractFieldTestRunSet,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldTestRunSet>>;
  public contractFieldsPost(
    body: ContractFieldTestRunSet,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldTestRunSet>>;
  public contractFieldsPost(
    body: ContractFieldTestRunSet,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractFieldsPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldTestRunSet>(
      'post',
      `${this.basePath}/contractfields`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約機械]をディーラー在庫に更新する
   * ディーラー在庫に更新する
   * @param body
   * @param contractmachineid 契約機械ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractMachinesContractMachineIdDealerStockPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractMachine>;
  public contractMachinesContractMachineIdDealerStockPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractMachine>>;
  public contractMachinesContractMachineIdDealerStockPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractMachine>>;
  public contractMachinesContractMachineIdDealerStockPut(
    body: ContractMachine,
    contractmachineid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractMachinesContractMachineIdDealerStockPut.'
      );
    }

    if (contractmachineid === null || contractmachineid === undefined) {
      throw new Error(
        'Required parameter contractmachineid was null or undefined when calling contractMachinesContractMachineIdDealerStockPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractMachine>(
      'put',
      `${this.basePath}/contractmachines/${encodeURIComponent(String(contractmachineid))}/dealerstock`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約機械]を1件取得する
   * * [契約機械]を1件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param contractmachineid 契約機械ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractMachinesContractMachineIdGet(
    contractmachineid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractMachine>;
  public contractMachinesContractMachineIdGet(
    contractmachineid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractMachine>>;
  public contractMachinesContractMachineIdGet(
    contractmachineid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractMachine>>;
  public contractMachinesContractMachineIdGet(
    contractmachineid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractmachineid === null || contractmachineid === undefined) {
      throw new Error(
        'Required parameter contractmachineid was null or undefined when calling contractMachinesContractMachineIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ContractMachine>(
      'get',
      `${this.basePath}/contractmachines/${encodeURIComponent(String(contractmachineid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約機械]を出荷検査済みに更新する
   * 出荷検査済みに更新する
   * @param body
   * @param contractmachineid 契約機械ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractMachinesContractMachineIdInspectedPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractMachine>;
  public contractMachinesContractMachineIdInspectedPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractMachine>>;
  public contractMachinesContractMachineIdInspectedPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractMachine>>;
  public contractMachinesContractMachineIdInspectedPut(
    body: ContractMachine,
    contractmachineid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractMachinesContractMachineIdInspectedPut.'
      );
    }

    if (contractmachineid === null || contractmachineid === undefined) {
      throw new Error(
        'Required parameter contractmachineid was null or undefined when calling contractMachinesContractMachineIdInspectedPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractMachine>(
      'put',
      `${this.basePath}/contractmachines/${encodeURIComponent(String(contractmachineid))}/inspected`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約機械]を更新する
   * 契約機械を更新する
   * @param body
   * @param contractmachineid 契約機械ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractMachinesContractMachineIdPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractMachine>;
  public contractMachinesContractMachineIdPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractMachine>>;
  public contractMachinesContractMachineIdPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractMachine>>;
  public contractMachinesContractMachineIdPut(
    body: ContractMachine,
    contractmachineid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractMachinesContractMachineIdPut.'
      );
    }

    if (contractmachineid === null || contractmachineid === undefined) {
      throw new Error(
        'Required parameter contractmachineid was null or undefined when calling contractMachinesContractMachineIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractMachine>(
      'put',
      `${this.basePath}/contractmachines/${encodeURIComponent(String(contractmachineid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約機械]を返品する
   * 返品する
   * @param body
   * @param contractmachineid 契約機械ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractMachinesContractMachineIdReturnPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContractMachine>>;
  public contractMachinesContractMachineIdReturnPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContractMachine>>>;
  public contractMachinesContractMachineIdReturnPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContractMachine>>>;
  public contractMachinesContractMachineIdReturnPut(
    body: ContractMachine,
    contractmachineid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractMachinesContractMachineIdReturnPut.'
      );
    }

    if (contractmachineid === null || contractmachineid === undefined) {
      throw new Error(
        'Required parameter contractmachineid was null or undefined when calling contractMachinesContractMachineIdReturnPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<ContractMachine>>(
      'put',
      `${this.basePath}/contractmachines/${encodeURIComponent(String(contractmachineid))}/return`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約機械]を出荷検査前に更新する
   * 出荷検査前に更新する
   * @param body
   * @param contractmachineid 契約機械ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractMachinesContractMachineIdRevertToBeforeInspectionPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractMachine>;
  public contractMachinesContractMachineIdRevertToBeforeInspectionPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractMachine>>;
  public contractMachinesContractMachineIdRevertToBeforeInspectionPut(
    body: ContractMachine,
    contractmachineid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractMachine>>;
  public contractMachinesContractMachineIdRevertToBeforeInspectionPut(
    body: ContractMachine,
    contractmachineid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractMachinesContractMachineIdRevertToBeforeInspectionPut.'
      );
    }

    if (contractmachineid === null || contractmachineid === undefined) {
      throw new Error(
        'Required parameter contractmachineid was null or undefined when calling contractMachinesContractMachineIdRevertToBeforeInspectionPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractMachine>(
      'put',
      `${this.basePath}/contractmachines/${encodeURIComponent(String(contractmachineid))}/reverttobeforeinspection`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約機械]を出荷する
   * 出荷する
   * @param body
   * @param contractcustomerid 契約顧客ID
   * @param contractmachineid 契約機械ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractMachinesContractMachineIdShipContractCustomerIdPut(
    body: ContractMachine,
    contractcustomerid: number,
    contractmachineid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContractMachine>>;
  public contractMachinesContractMachineIdShipContractCustomerIdPut(
    body: ContractMachine,
    contractcustomerid: number,
    contractmachineid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContractMachine>>>;
  public contractMachinesContractMachineIdShipContractCustomerIdPut(
    body: ContractMachine,
    contractcustomerid: number,
    contractmachineid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContractMachine>>>;
  public contractMachinesContractMachineIdShipContractCustomerIdPut(
    body: ContractMachine,
    contractcustomerid: number,
    contractmachineid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractMachinesContractMachineIdShipContractCustomerIdPut.'
      );
    }

    if (contractcustomerid === null || contractcustomerid === undefined) {
      throw new Error(
        'Required parameter contractcustomerid was null or undefined when calling contractMachinesContractMachineIdShipContractCustomerIdPut.'
      );
    }

    if (contractmachineid === null || contractmachineid === undefined) {
      throw new Error(
        'Required parameter contractmachineid was null or undefined when calling contractMachinesContractMachineIdShipContractCustomerIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Array<ContractMachine>>(
      'put',
      `${this.basePath}/contractmachines/${encodeURIComponent(String(contractmachineid))}/ship/${encodeURIComponent(String(contractcustomerid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約機械]を複数件取得する
   * * [契約機械]を複数件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param contractCustomerId 契約顧客ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractMachinesGet(
    contractCustomerId?: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContractMachine>>;
  public contractMachinesGet(
    contractCustomerId?: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContractMachine>>>;
  public contractMachinesGet(
    contractCustomerId?: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContractMachine>>>;
  public contractMachinesGet(
    contractCustomerId?: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (contractCustomerId !== undefined && contractCustomerId !== null) {
      queryParameters = queryParameters.set(
        'contractCustomerId',
        <any>contractCustomerId
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<ContractMachine>>(
      'get',
      `${this.basePath}/contractmachines`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約ユーザ]を削除する
   * [契約ユーザ]を削除する
   * @param body
   * @param contractuserid 契約ユーザID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractUsersContractUserIdDeletePut(
    body: ContractUser,
    contractuserid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractUser>;
  public contractUsersContractUserIdDeletePut(
    body: ContractUser,
    contractuserid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractUser>>;
  public contractUsersContractUserIdDeletePut(
    body: ContractUser,
    contractuserid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractUser>>;
  public contractUsersContractUserIdDeletePut(
    body: ContractUser,
    contractuserid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractUsersContractUserIdDeletePut.'
      );
    }

    if (contractuserid === null || contractuserid === undefined) {
      throw new Error(
        'Required parameter contractuserid was null or undefined when calling contractUsersContractUserIdDeletePut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractUser>(
      'put',
      `${this.basePath}/contractusers/${encodeURIComponent(String(contractuserid))}/delete`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約ユーザ]を1件取得する
   * * [契約ユーザ]を1件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param contractuserid 契約ユーザID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractUsersContractUserIdGet(
    contractuserid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractUser>;
  public contractUsersContractUserIdGet(
    contractuserid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractUser>>;
  public contractUsersContractUserIdGet(
    contractuserid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractUser>>;
  public contractUsersContractUserIdGet(
    contractuserid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractuserid === null || contractuserid === undefined) {
      throw new Error(
        'Required parameter contractuserid was null or undefined when calling contractUsersContractUserIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ContractUser>(
      'get',
      `${this.basePath}/contractusers/${encodeURIComponent(String(contractuserid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約ユーザ]を更新する
   * 契約ユーザを更新する
   * @param body
   * @param contractuserid 契約ユーザID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractUsersContractUserIdPut(
    body: ContractUser,
    contractuserid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractUser>;
  public contractUsersContractUserIdPut(
    body: ContractUser,
    contractuserid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractUser>>;
  public contractUsersContractUserIdPut(
    body: ContractUser,
    contractuserid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractUser>>;
  public contractUsersContractUserIdPut(
    body: ContractUser,
    contractuserid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractUsersContractUserIdPut.'
      );
    }

    if (contractuserid === null || contractuserid === undefined) {
      throw new Error(
        'Required parameter contractuserid was null or undefined when calling contractUsersContractUserIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractUser>(
      'put',
      `${this.basePath}/contractusers/${encodeURIComponent(String(contractuserid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約ユーザ]を複数件取得する
   * * [契約ユーザ]を複数件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param contractCustomerId 契約顧客ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractUsersGet(
    contractCustomerId?: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContractUser>>;
  public contractUsersGet(
    contractCustomerId?: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContractUser>>>;
  public contractUsersGet(
    contractCustomerId?: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContractUser>>>;
  public contractUsersGet(
    contractCustomerId?: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (contractCustomerId !== undefined && contractCustomerId !== null) {
      queryParameters = queryParameters.set(
        'contractCustomerId',
        <any>contractCustomerId
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<ContractUser>>(
      'get',
      `${this.basePath}/contractusers`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約ユーザ]を登録する
   * 契約ユーザを登録する
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractUsersPost(
    body: ContractUser,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractUser>;
  public contractUsersPost(
    body: ContractUser,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractUser>>;
  public contractUsersPost(
    body: ContractUser,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractUser>>;
  public contractUsersPost(
    body: ContractUser,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractUsersPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractUser>(
      'post',
      `${this.basePath}/contractusers`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約者]を削除する
   * [契約者]を削除する
   * @param body
   * @param contractid 契約者ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractsContractIdDeletePut(
    body: Contract,
    contractid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Contract>;
  public contractsContractIdDeletePut(
    body: Contract,
    contractid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Contract>>;
  public contractsContractIdDeletePut(
    body: Contract,
    contractid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Contract>>;
  public contractsContractIdDeletePut(
    body: Contract,
    contractid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractsContractIdDeletePut.'
      );
    }

    if (contractid === null || contractid === undefined) {
      throw new Error(
        'Required parameter contractid was null or undefined when calling contractsContractIdDeletePut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Contract>(
      'put',
      `${this.basePath}/contracts/${encodeURIComponent(String(contractid))}/delete`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約者]を1件取得する
   * * [契約者]を1件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param contractid 契約者ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractsContractIdGet(
    contractid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Contract>;
  public contractsContractIdGet(
    contractid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Contract>>;
  public contractsContractIdGet(
    contractid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Contract>>;
  public contractsContractIdGet(
    contractid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (contractid === null || contractid === undefined) {
      throw new Error(
        'Required parameter contractid was null or undefined when calling contractsContractIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Contract>(
      'get',
      `${this.basePath}/contracts/${encodeURIComponent(String(contractid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約者]を更新する
   * 契約者を更新する
   * @param body
   * @param contractid 契約者ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractsContractIdPut(
    body: Contract,
    contractid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Contract>;
  public contractsContractIdPut(
    body: Contract,
    contractid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Contract>>;
  public contractsContractIdPut(
    body: Contract,
    contractid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Contract>>;
  public contractsContractIdPut(
    body: Contract,
    contractid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractsContractIdPut.'
      );
    }

    if (contractid === null || contractid === undefined) {
      throw new Error(
        'Required parameter contractid was null or undefined when calling contractsContractIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Contract>(
      'put',
      `${this.basePath}/contracts/${encodeURIComponent(String(contractid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約者]を複数件取得する
   * * [契約者]を複数件取得する。   * 所属するリソースを操作する。   * 所属するリソースを操作する。
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractsGet(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<Contract>>;
  public contractsGet(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Contract>>>;
  public contractsGet(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Contract>>>;
  public contractsGet(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<Contract>>(
      'get',
      `${this.basePath}/contracts`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約者]を登録する
   * 契約者を登録する
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public contractsPost(
    body: Contract,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Contract>;
  public contractsPost(
    body: Contract,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Contract>>;
  public contractsPost(
    body: Contract,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Contract>>;
  public contractsPost(
    body: Contract,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling contractsPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Contract>(
      'post',
      `${this.basePath}/contracts`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [圃場]を登録する
   * [圃場]を登録する
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsAdapterPost(
    body: Field,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Field>;
  public fieldsAdapterPost(
    body: Field,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Field>>;
  public fieldsAdapterPost(
    body: Field,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Field>>;
  public fieldsAdapterPost(
    body: Field,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling fieldsAdapterPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Field>('post', `${this.basePath}/fields`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * [圃場]を更新する
   * [圃場]を更新する
   * @param body
   * @param fieldid 圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsFieldIdAdapterPut(
    body: Field,
    fieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Field>;
  public fieldsFieldIdAdapterPut(
    body: Field,
    fieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Field>>;
  public fieldsFieldIdAdapterPut(
    body: Field,
    fieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Field>>;
  public fieldsFieldIdAdapterPut(
    body: Field,
    fieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling fieldsFieldIdAdapterPut.'
      );
    }

    if (fieldid === null || fieldid === undefined) {
      throw new Error(
        'Required parameter fieldid was null or undefined when calling fieldsFieldIdAdapterPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Field>(
      'put',
      `${this.basePath}/fields/${encodeURIComponent(String(fieldid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場測量]を取得する
   * [契約圃場測量]を取得する
   * @param fieldid 圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsFieldIdContractFieldMeasurementsAdapterGet(
    fieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContractFieldMeasurement>>;
  public fieldsFieldIdContractFieldMeasurementsAdapterGet(
    fieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContractFieldMeasurement>>>;
  public fieldsFieldIdContractFieldMeasurementsAdapterGet(
    fieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContractFieldMeasurement>>>;
  public fieldsFieldIdContractFieldMeasurementsAdapterGet(
    fieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (fieldid === null || fieldid === undefined) {
      throw new Error(
        'Required parameter fieldid was null or undefined when calling fieldsFieldIdContractFieldMeasurementsAdapterGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<ContractFieldMeasurement>>(
      'get',
      `${this.basePath}/fields/${encodeURIComponent(String(fieldid))}/contractfieldmeasurements`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場測量]を登録する
   * [契約圃場測量]を登録する
   * @param body
   * @param fieldid 圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsFieldIdContractFieldMeasurementsAdapterPost(
    body: ContractFieldMeasurement,
    fieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldMeasurement>;
  public fieldsFieldIdContractFieldMeasurementsAdapterPost(
    body: ContractFieldMeasurement,
    fieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldMeasurement>>;
  public fieldsFieldIdContractFieldMeasurementsAdapterPost(
    body: ContractFieldMeasurement,
    fieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldMeasurement>>;
  public fieldsFieldIdContractFieldMeasurementsAdapterPost(
    body: ContractFieldMeasurement,
    fieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling fieldsFieldIdContractFieldMeasurementsAdapterPost.'
      );
    }

    if (fieldid === null || fieldid === undefined) {
      throw new Error(
        'Required parameter fieldid was null or undefined when calling fieldsFieldIdContractFieldMeasurementsAdapterPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldMeasurement>(
      'post',
      `${this.basePath}/fields/${encodeURIComponent(String(fieldid))}/contractfieldmeasurements`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場測量]を1件取得する
   * [契約圃場測量]を1件取得する
   * @param contractfieldmeasurementid 契約圃場測量ID
   * @param fieldid 圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterGet(
    contractfieldmeasurementid: number,
    fieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldMeasurement>;
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterGet(
    contractfieldmeasurementid: number,
    fieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldMeasurement>>;
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterGet(
    contractfieldmeasurementid: number,
    fieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldMeasurement>>;
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterGet(
    contractfieldmeasurementid: number,
    fieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (
      contractfieldmeasurementid === null ||
      contractfieldmeasurementid === undefined
    ) {
      throw new Error(
        'Required parameter contractfieldmeasurementid was null or undefined when calling fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterGet.'
      );
    }

    if (fieldid === null || fieldid === undefined) {
      throw new Error(
        'Required parameter fieldid was null or undefined when calling fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ContractFieldMeasurement>(
      'get',
      `${this.basePath}/fields/${encodeURIComponent(String(fieldid))}/contractfieldmeasurements/${encodeURIComponent(String(contractfieldmeasurementid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [契約圃場測量]を更新する
   * [契約圃場測量]を更新する
   * @param body
   * @param contractfieldmeasurementid 契約圃場測量ID
   * @param fieldid 圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterPut(
    body: ContractFieldMeasurement,
    contractfieldmeasurementid: number,
    fieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContractFieldMeasurement>;
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterPut(
    body: ContractFieldMeasurement,
    contractfieldmeasurementid: number,
    fieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContractFieldMeasurement>>;
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterPut(
    body: ContractFieldMeasurement,
    contractfieldmeasurementid: number,
    fieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContractFieldMeasurement>>;
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterPut(
    body: ContractFieldMeasurement,
    contractfieldmeasurementid: number,
    fieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterPut.'
      );
    }

    if (
      contractfieldmeasurementid === null ||
      contractfieldmeasurementid === undefined
    ) {
      throw new Error(
        'Required parameter contractfieldmeasurementid was null or undefined when calling fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterPut.'
      );
    }

    if (fieldid === null || fieldid === undefined) {
      throw new Error(
        'Required parameter fieldid was null or undefined when calling fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdAdapterPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ContractFieldMeasurement>(
      'put',
      `${this.basePath}/fields/${encodeURIComponent(String(fieldid))}/contractfieldmeasurements/${encodeURIComponent(String(contractfieldmeasurementid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [圃場測量座標情報]を取得する
   * [圃場測量座標情報]を取得する
   * @param contractfieldmeasurementid 契約圃場測量ID
   * @param fieldid 圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet(
    contractfieldmeasurementid: number,
    fieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<FieldMeasurementCoordinateInfo>;
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet(
    contractfieldmeasurementid: number,
    fieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<FieldMeasurementCoordinateInfo>>;
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet(
    contractfieldmeasurementid: number,
    fieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<FieldMeasurementCoordinateInfo>>;
  public fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet(
    contractfieldmeasurementid: number,
    fieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (
      contractfieldmeasurementid === null ||
      contractfieldmeasurementid === undefined
    ) {
      throw new Error(
        'Required parameter contractfieldmeasurementid was null or undefined when calling fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet.'
      );
    }

    if (fieldid === null || fieldid === undefined) {
      throw new Error(
        'Required parameter fieldid was null or undefined when calling fieldsFieldIdContractFieldMeasurementsContractFieldMeasurementIdFieldMeasurementCoordinateInfoGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<FieldMeasurementCoordinateInfo>(
      'get',
      `${this.basePath}/fields/${encodeURIComponent(String(fieldid))}/contractfieldmeasurements/${encodeURIComponent(String(contractfieldmeasurementid))}/fieldmeasurementcoordinateinfo`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [圃場]を1件取得する
   * * [圃場]を1件取得する
   * @param fieldid 圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsFieldIdGet(
    fieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Field>;
  public fieldsFieldIdGet(
    fieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Field>>;
  public fieldsFieldIdGet(
    fieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Field>>;
  public fieldsFieldIdGet(
    fieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (fieldid === null || fieldid === undefined) {
      throw new Error(
        'Required parameter fieldid was null or undefined when calling fieldsFieldIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Field>(
      'get',
      `${this.basePath}/fields/${encodeURIComponent(String(fieldid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業経路]を取得する
   * [作業経路]を取得する
   * @param fieldid 圃場ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsFieldIdWorkPathsGet(
    fieldid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<WorkPath>>;
  public fieldsFieldIdWorkPathsGet(
    fieldid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<WorkPath>>>;
  public fieldsFieldIdWorkPathsGet(
    fieldid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<WorkPath>>>;
  public fieldsFieldIdWorkPathsGet(
    fieldid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (fieldid === null || fieldid === undefined) {
      throw new Error(
        'Required parameter fieldid was null or undefined when calling fieldsFieldIdWorkPathsGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<WorkPath>>(
      'get',
      `${this.basePath}/fields/${encodeURIComponent(String(fieldid))}/workpaths`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業経路]を1件取得する
   * [作業経路]を1件取得する
   * @param fieldid 圃場ID
   * @param workpathid 作業経路ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsFieldIdWorkPathsWorkPathIdGet(
    fieldid: number,
    workpathid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPath>;
  public fieldsFieldIdWorkPathsWorkPathIdGet(
    fieldid: number,
    workpathid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPath>>;
  public fieldsFieldIdWorkPathsWorkPathIdGet(
    fieldid: number,
    workpathid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPath>>;
  public fieldsFieldIdWorkPathsWorkPathIdGet(
    fieldid: number,
    workpathid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (fieldid === null || fieldid === undefined) {
      throw new Error(
        'Required parameter fieldid was null or undefined when calling fieldsFieldIdWorkPathsWorkPathIdGet.'
      );
    }

    if (workpathid === null || workpathid === undefined) {
      throw new Error(
        'Required parameter workpathid was null or undefined when calling fieldsFieldIdWorkPathsWorkPathIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<WorkPath>(
      'get',
      `${this.basePath}/fields/${encodeURIComponent(String(fieldid))}/workpaths/${encodeURIComponent(String(workpathid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業圃場走行経路情報]を取得する
   * [作業圃場走行経路情報]を取得する
   * @param fieldid 圃場ID
   * @param workpathid 作業経路ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsFieldIdWorkPathsWorkPathIdWorkFieldRunPathInfosGet(
    fieldid: number,
    workpathid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<WorkFieldRunPathInfo>>;
  public fieldsFieldIdWorkPathsWorkPathIdWorkFieldRunPathInfosGet(
    fieldid: number,
    workpathid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<WorkFieldRunPathInfo>>>;
  public fieldsFieldIdWorkPathsWorkPathIdWorkFieldRunPathInfosGet(
    fieldid: number,
    workpathid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<WorkFieldRunPathInfo>>>;
  public fieldsFieldIdWorkPathsWorkPathIdWorkFieldRunPathInfosGet(
    fieldid: number,
    workpathid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (fieldid === null || fieldid === undefined) {
      throw new Error(
        'Required parameter fieldid was null or undefined when calling fieldsFieldIdWorkPathsWorkPathIdWorkFieldRunPathInfosGet.'
      );
    }

    if (workpathid === null || workpathid === undefined) {
      throw new Error(
        'Required parameter workpathid was null or undefined when calling fieldsFieldIdWorkPathsWorkPathIdWorkFieldRunPathInfosGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<WorkFieldRunPathInfo>>(
      'get',
      `${this.basePath}/fields/${encodeURIComponent(String(fieldid))}/workpaths/${encodeURIComponent(String(workpathid))}/workfieldrunpathinfos`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [圃場]を複数件取得する
   * * [圃場]を複数件取得する。   * 所属するワイナリー(契約者)配下のリソースを操作する。   * 所属する圃場グループ配下のリソースを操作する。
   * @param isall 全圃場（利用できる作業経路がない圃場も含む）かどうか
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public fieldsGet(
    isall?: boolean,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<Field>>;
  public fieldsGet(
    isall?: boolean,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Field>>>;
  public fieldsGet(
    isall?: boolean,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Field>>>;
  public fieldsGet(
    isall?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (isall !== undefined && isall !== null) {
      queryParameters = queryParameters.set('isall', <any>isall);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<Field>>(
      'get',
      `${this.basePath}/fields`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [インプルメント]を取得する
   * [インプルメント]を取得する
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public implementsGet(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<Implement>>;
  public implementsGet(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Implement>>>;
  public implementsGet(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Implement>>>;
  public implementsGet(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<Implement>>(
      'get',
      `${this.basePath}/implements`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [インプルメント]を削除する
   * [インプルメント]を削除する
   * @param body
   * @param implementid インプルメントID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public implementsImplementIdDeletePut(
    body: Implement,
    implementid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Implement>;
  public implementsImplementIdDeletePut(
    body: Implement,
    implementid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Implement>>;
  public implementsImplementIdDeletePut(
    body: Implement,
    implementid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Implement>>;
  public implementsImplementIdDeletePut(
    body: Implement,
    implementid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling implementsImplementIdDeletePut.'
      );
    }

    if (implementid === null || implementid === undefined) {
      throw new Error(
        'Required parameter implementid was null or undefined when calling implementsImplementIdDeletePut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Implement>(
      'put',
      `${this.basePath}/implements/${encodeURIComponent(String(implementid))}/delete`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [インプルメント]を1件取得する
   * [インプルメント]を1件取得する
   * @param implementid インプルメントID
   * @param isincludedeleted 削除済みを含む
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public implementsImplementIdGet(
    implementid: number,
    isincludedeleted?: boolean,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Implement>;
  public implementsImplementIdGet(
    implementid: number,
    isincludedeleted?: boolean,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Implement>>;
  public implementsImplementIdGet(
    implementid: number,
    isincludedeleted?: boolean,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Implement>>;
  public implementsImplementIdGet(
    implementid: number,
    isincludedeleted?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (implementid === null || implementid === undefined) {
      throw new Error(
        'Required parameter implementid was null or undefined when calling implementsImplementIdGet.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (isincludedeleted !== undefined && isincludedeleted !== null) {
      queryParameters = queryParameters.set(
        'isincludedeleted',
        <any>isincludedeleted
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Implement>(
      'get',
      `${this.basePath}/implements/${encodeURIComponent(String(implementid))}`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [インプルメント]を更新する
   * [インプルメント]を更新する
   * @param body
   * @param implementid インプルメントID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public implementsImplementIdPut(
    body: Implement,
    implementid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Implement>;
  public implementsImplementIdPut(
    body: Implement,
    implementid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Implement>>;
  public implementsImplementIdPut(
    body: Implement,
    implementid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Implement>>;
  public implementsImplementIdPut(
    body: Implement,
    implementid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling implementsImplementIdPut.'
      );
    }

    if (implementid === null || implementid === undefined) {
      throw new Error(
        'Required parameter implementid was null or undefined when calling implementsImplementIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Implement>(
      'put',
      `${this.basePath}/implements/${encodeURIComponent(String(implementid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [インプルメント]を登録する
   * [インプルメント]を登録する
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public implementsPost(
    body: Implement,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Implement>;
  public implementsPost(
    body: Implement,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Implement>>;
  public implementsPost(
    body: Implement,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Implement>>;
  public implementsPost(
    body: Implement,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling implementsPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Implement>(
      'post',
      `${this.basePath}/implements`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [本機稼働情報]を1件取得する
   * [本機稼働情報]を機械IDをキーとして1件取得します。
   * @param machineid 機械ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public machineMonitorsMachineIdGet(
    machineid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<MachineOperationInfo>;
  public machineMonitorsMachineIdGet(
    machineid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<MachineOperationInfo>>;
  public machineMonitorsMachineIdGet(
    machineid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<MachineOperationInfo>>;
  public machineMonitorsMachineIdGet(
    machineid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (machineid === null || machineid === undefined) {
      throw new Error(
        'Required parameter machineid was null or undefined when calling machineMonitorsMachineIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<MachineOperationInfo>(
      'get',
      `${this.basePath}/machinemonitors/${encodeURIComponent(String(machineid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * 本機をSuspendする
   * 本機を機械IDをキーとしてSuspendします。
   * @param body
   * @param machineid 機械ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public machineMonitorsMachineIdSuspendPut(
    body: MachineOperationInfo,
    machineid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<MachineOperationInfo>;
  public machineMonitorsMachineIdSuspendPut(
    body: MachineOperationInfo,
    machineid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<MachineOperationInfo>>;
  public machineMonitorsMachineIdSuspendPut(
    body: MachineOperationInfo,
    machineid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<MachineOperationInfo>>;
  public machineMonitorsMachineIdSuspendPut(
    body: MachineOperationInfo,
    machineid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling machineMonitorsMachineIdSuspendPut.'
      );
    }

    if (machineid === null || machineid === undefined) {
      throw new Error(
        'Required parameter machineid was null or undefined when calling machineMonitorsMachineIdSuspendPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<MachineOperationInfo>(
      'put',
      `${this.basePath}/machinemonitors/${encodeURIComponent(String(machineid))}/suspend`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [機械(本機)]を複数件取得する
   * * [機械(本機)]を複数件取得する。   * 所属するワイナリー(契約者)配下のリソースを操作する。   * 所属する機械グループ配下のリソースを操作する。
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public machinesGet(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<Machine>>;
  public machinesGet(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Machine>>>;
  public machinesGet(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Machine>>>;
  public machinesGet(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<Machine>>(
      'get',
      `${this.basePath}/machines`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [機械(本機)]を1件取得する
   * * [機械(本機)]を1件取得する。   * 所属するワイナリー(契約者)配下のリソースを操作する。   * 所属する機械グループ配下のリソースを操作する。
   * @param machineid 機械ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public machinesMachineIdGet(
    machineid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Machine>;
  public machinesMachineIdGet(
    machineid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Machine>>;
  public machinesMachineIdGet(
    machineid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Machine>>;
  public machinesMachineIdGet(
    machineid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (machineid === null || machineid === undefined) {
      throw new Error(
        'Required parameter machineid was null or undefined when calling machinesMachineIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Machine>(
      'get',
      `${this.basePath}/machines/${encodeURIComponent(String(machineid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [レシピ]を複数件取得する
   * * [レシピ]を複数件取得する。   * 所属するワイナリー(契約者)配下のリソースを操作する。
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recipesGet(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<Recipe>>;
  public recipesGet(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<Recipe>>>;
  public recipesGet(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<Recipe>>>;
  public recipesGet(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<Recipe>>(
      'get',
      `${this.basePath}/recipes`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [レシピ]を1件取得する
   * * [レシピ]を1件取得する。   * 所属するワイナリー(契約者)配下のリソースを操作する。
   * @param recipeid レシピID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recipesRecipeidGet(
    recipeid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Recipe>;
  public recipesRecipeidGet(
    recipeid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Recipe>>;
  public recipesRecipeidGet(
    recipeid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Recipe>>;
  public recipesRecipeidGet(
    recipeid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (recipeid === null || recipeid === undefined) {
      throw new Error(
        'Required parameter recipeid was null or undefined when calling recipesRecipeidGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Recipe>(
      'get',
      `${this.basePath}/recipes/${encodeURIComponent(String(recipeid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [ユーザー]を取得する
   * * ログイン中の[ユーザー]を1件取得する。 * 認証情報から取得したユーザアカウントで検索する。
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public vineyardUsersGet(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VineyardUser>;
  public vineyardUsersGet(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VineyardUser>>;
  public vineyardUsersGet(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VineyardUser>>;
  public vineyardUsersGet(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<VineyardUser>(
      'get',
      `${this.basePath}/vineyardusers`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [ユーザー]を1件取得する
   * * [ユーザー]を1件取得する。   * 所属するワイナリー(契約者)配下のリソースを操作する。   * 所属するユーザグループ配下のリソースを操作する。
   * @param account ユーザアカウント
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public vineyardusersAccountGet(
    account: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VineyardUser>;
  public vineyardusersAccountGet(
    account: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VineyardUser>>;
  public vineyardusersAccountGet(
    account: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VineyardUser>>;
  public vineyardusersAccountGet(
    account: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (account === null || account === undefined) {
      throw new Error(
        'Required parameter account was null or undefined when calling vineyardusersAccountGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<VineyardUser>(
      'get',
      `${this.basePath}/vineyardusers/${encodeURIComponent(String(account))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業予定](Draft)を作成する
   * 作成中の[作業予定]を作成する。
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansDraftPost(
    body: WorkPlan,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public workPlansDraftPost(
    body: WorkPlan,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public workPlansDraftPost(
    body: WorkPlan,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public workPlansDraftPost(
    body: WorkPlan,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling workPlansDraftPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<WorkPlan>(
      'post',
      `${this.basePath}/workplans/draft`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業予定]を取得する
   * [作業予定]を取得する。
   * @param workStatus 作業ステータスリスト
   * @param workerid 作業者
   * @param workmachineid 作業機械
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansGet(
    workStatus: Array<string>,
    workerid: number,
    workmachineid?: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<WorkPlan>>;
  public workPlansGet(
    workStatus: Array<string>,
    workerid: number,
    workmachineid?: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<WorkPlan>>>;
  public workPlansGet(
    workStatus: Array<string>,
    workerid: number,
    workmachineid?: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<WorkPlan>>>;
  public workPlansGet(
    workStatus: Array<string>,
    workerid: number,
    workmachineid?: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (workStatus === null || workStatus === undefined) {
      throw new Error(
        'Required parameter workStatus was null or undefined when calling workPlansGet.'
      );
    }

    if (workerid === null || workerid === undefined) {
      throw new Error(
        'Required parameter workerid was null or undefined when calling workPlansGet.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (workStatus) {
      workStatus.forEach((element) => {
        queryParameters = queryParameters.append('workStatus', <any>element);
      });
    }
    if (workerid !== undefined && workerid !== null) {
      queryParameters = queryParameters.set('workerid', <any>workerid);
    }
    if (workmachineid !== undefined && workmachineid !== null) {
      queryParameters = queryParameters.set(
        'workmachineid',
        <any>workmachineid
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<WorkPlan>>(
      'get',
      `${this.basePath}/workplans`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業予定]を作成する
   * [作業予定]を作成する。
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansPost(
    body: WorkPlan,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public workPlansPost(
    body: WorkPlan,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public workPlansPost(
    body: WorkPlan,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public workPlansPost(
    body: WorkPlan,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling workPlansPost.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<WorkPlan>(
      'post',
      `${this.basePath}/workplans`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * 作業スケジュール（[作業予定]）を取得する
   * 作業スケジュール（[作業予定]）を取得する
   * @param workdate 作業日
   * @param workerid 作業者
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansScheduleGet(
    workdate: string,
    workerid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<WorkPlan>>;
  public workPlansScheduleGet(
    workdate: string,
    workerid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<WorkPlan>>>;
  public workPlansScheduleGet(
    workdate: string,
    workerid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<WorkPlan>>>;
  public workPlansScheduleGet(
    workdate: string,
    workerid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (workdate === null || workdate === undefined) {
      throw new Error(
        'Required parameter workdate was null or undefined when calling workPlansScheduleGet.'
      );
    }

    if (workerid === null || workerid === undefined) {
      throw new Error(
        'Required parameter workerid was null or undefined when calling workPlansScheduleGet.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (workdate !== undefined && workdate !== null) {
      queryParameters = queryParameters.set('workdate', <any>workdate);
    }
    if (workerid !== undefined && workerid !== null) {
      queryParameters = queryParameters.set('workerid', <any>workerid);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<WorkPlan>>(
      'get',
      `${this.basePath}/workplans/schedule`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業予定]をBeginする
   * [作業予定]を更新し、[機械(本機)]に&#x27;Begin&#x27;を行います。
   * @param body
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdBeginPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public workPlansWorkPlanIdBeginPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public workPlansWorkPlanIdBeginPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public workPlansWorkPlanIdBeginPut(
    body: WorkPlan,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling workPlansWorkPlanIdBeginPut.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdBeginPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<WorkPlan>(
      'put',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}/begin`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業予定]をDoneする
   * 作業完了
   * @param body
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdDonePut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public workPlansWorkPlanIdDonePut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public workPlansWorkPlanIdDonePut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public workPlansWorkPlanIdDonePut(
    body: WorkPlan,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling workPlansWorkPlanIdDonePut.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdDonePut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<WorkPlan>(
      'put',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}/done`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業予定](Draft)を更新する
   * 作成中の[作業予定]を更新する
   * @param body
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdDraftPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public workPlansWorkPlanIdDraftPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public workPlansWorkPlanIdDraftPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public workPlansWorkPlanIdDraftPut(
    body: WorkPlan,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling workPlansWorkPlanIdDraftPut.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdDraftPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<WorkPlan>(
      'put',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}/draft`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業予定]を1件取得する
   * [作業予定]を1件取得する
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdGet(
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public workPlansWorkPlanIdGet(
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public workPlansWorkPlanIdGet(
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public workPlansWorkPlanIdGet(
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<WorkPlan>(
      'get',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業予定]を更新する
   * [作業予定]を更新する
   * @param body
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public workPlansWorkPlanIdPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public workPlansWorkPlanIdPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public workPlansWorkPlanIdPut(
    body: WorkPlan,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling workPlansWorkPlanIdPut.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<WorkPlan>(
      'put',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業予定]をQuitする
   * [本機稼働情報]に紐づけた[機械(本機)]の[作業]をQuitする。
   * @param body
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdQuitPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public workPlansWorkPlanIdQuitPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public workPlansWorkPlanIdQuitPut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public workPlansWorkPlanIdQuitPut(
    body: WorkPlan,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling workPlansWorkPlanIdQuitPut.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdQuitPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<WorkPlan>(
      'put',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}/quit`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * 作業圃場走行経路情報を複数件取得する
   * * 作業圃場走行経路情報を複数件取得する
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdWorkFieldRunPathInfosGet(
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<WorkFieldRunPathInfo>>;
  public workPlansWorkPlanIdWorkFieldRunPathInfosGet(
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<WorkFieldRunPathInfo>>>;
  public workPlansWorkPlanIdWorkFieldRunPathInfosGet(
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<WorkFieldRunPathInfo>>>;
  public workPlansWorkPlanIdWorkFieldRunPathInfosGet(
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdWorkFieldRunPathInfosGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<WorkFieldRunPathInfo>>(
      'get',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}/workfieldrunpathinfos`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業履歴]を複数件取得する
   * 作業予定Idで[作業履歴]を複数件取得する。 リストの順序は作業開始日時の昇順にする
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdWorkHistoriesGet(
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<WorkHistory>>;
  public workPlansWorkPlanIdWorkHistoriesGet(
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<WorkHistory>>>;
  public workPlansWorkPlanIdWorkHistoriesGet(
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<WorkHistory>>>;
  public workPlansWorkPlanIdWorkHistoriesGet(
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdWorkHistoriesGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<WorkHistory>>(
      'get',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}/workhistories`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業履歴]を1件取得する
   * [作業履歴]を1件取得する
   * @param workhistoryid 作業履歴ID
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdWorkHistoriesWorkHistoryIdGet(
    workhistoryid: number,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkHistory>;
  public workPlansWorkPlanIdWorkHistoriesWorkHistoryIdGet(
    workhistoryid: number,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkHistory>>;
  public workPlansWorkPlanIdWorkHistoriesWorkHistoryIdGet(
    workhistoryid: number,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkHistory>>;
  public workPlansWorkPlanIdWorkHistoriesWorkHistoryIdGet(
    workhistoryid: number,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (workhistoryid === null || workhistoryid === undefined) {
      throw new Error(
        'Required parameter workhistoryid was null or undefined when calling workPlansWorkPlanIdWorkHistoriesWorkHistoryIdGet.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdWorkHistoriesWorkHistoryIdGet.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<WorkHistory>(
      'get',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}/workhistories/${encodeURIComponent(String(workhistoryid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業履歴]を更新する
   * 作業履歴Idで[作業履歴]を更新する
   * @param body
   * @param workhistoryid 作業履歴ID
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdWorkHistoriesWorkHistoryIdPut(
    body: WorkHistory,
    workhistoryid: number,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkHistory>;
  public workPlansWorkPlanIdWorkHistoriesWorkHistoryIdPut(
    body: WorkHistory,
    workhistoryid: number,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkHistory>>;
  public workPlansWorkPlanIdWorkHistoriesWorkHistoryIdPut(
    body: WorkHistory,
    workhistoryid: number,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkHistory>>;
  public workPlansWorkPlanIdWorkHistoriesWorkHistoryIdPut(
    body: WorkHistory,
    workhistoryid: number,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling workPlansWorkPlanIdWorkHistoriesWorkHistoryIdPut.'
      );
    }

    if (workhistoryid === null || workhistoryid === undefined) {
      throw new Error(
        'Required parameter workhistoryid was null or undefined when calling workPlansWorkPlanIdWorkHistoriesWorkHistoryIdPut.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdWorkHistoriesWorkHistoryIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<WorkHistory>(
      'put',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}/workhistories/${encodeURIComponent(String(workhistoryid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業インプルメント]を更新する
   * [作業インプルメント]を更新する
   * @param body
   * @param workplanid 作業予定ID
   * @param workimplementid 作業インプルメントID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workPlansWorkPlanIdWorkImplementsWorkImplementIdPut(
    body: WorkPlan,
    workplanid: number,
    workimplementid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public workPlansWorkPlanIdWorkImplementsWorkImplementIdPut(
    body: WorkPlan,
    workplanid: number,
    workimplementid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public workPlansWorkPlanIdWorkImplementsWorkImplementIdPut(
    body: WorkPlan,
    workplanid: number,
    workimplementid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public workPlansWorkPlanIdWorkImplementsWorkImplementIdPut(
    body: WorkPlan,
    workplanid: number,
    workimplementid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling workPlansWorkPlanIdWorkImplementsWorkImplementIdPut.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workPlansWorkPlanIdWorkImplementsWorkImplementIdPut.'
      );
    }

    if (workimplementid === null || workimplementid === undefined) {
      throw new Error(
        'Required parameter workimplementid was null or undefined when calling workPlansWorkPlanIdWorkImplementsWorkImplementIdPut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<WorkPlan>(
      'put',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}/workimplements/${encodeURIComponent(String(workimplementid))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * [作業予定]を削除する
   * [作業予定]を削除する
   * @param body
   * @param workplanid 作業予定ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public workplansWorkplanidDeletePut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkPlan>;
  public workplansWorkplanidDeletePut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkPlan>>;
  public workplansWorkplanidDeletePut(
    body: WorkPlan,
    workplanid: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkPlan>>;
  public workplansWorkplanidDeletePut(
    body: WorkPlan,
    workplanid: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling workplansWorkplanidDeletePut.'
      );
    }

    if (workplanid === null || workplanid === undefined) {
      throw new Error(
        'Required parameter workplanid was null or undefined when calling workplansWorkplanidDeletePut.'
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<WorkPlan>(
      'put',
      `${this.basePath}/workplans/${encodeURIComponent(String(workplanid))}/delete`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
